import http from '@/services/http'

export default {
  namespaced: true,
  actions: {
    async getSystemInfo({ rootState }) {
      const res = await http.get(`system_info/manufacture/${rootState.manufactures.selectedManufacture.id}/main`)
      return res
    }
  }
}